import { relations } from 'drizzle-orm'
import { boolean, integer, jsonb, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { DEFAULT_FOLLOW_UP_PHASES, type FollowUpPhaseDefinition } from '../../constants/skill-check'
import { tenants } from './tenants'

// Tenant Training Configs
export const tenantTrainingConfigs = pgTable('tenant_training_configs', {
  id: uuid('id').primaryKey().defaultRandom(),
  defaultNotificationChannel: text('default_notification_channel').notNull().default('teams'),
  defaultHrContactEmail: text('default_hr_contact_email'),
  teamsWebhookUrl: text('teams_webhook_url'),
  followUpPhases: jsonb('follow_up_phases')
    .$type<FollowUpPhaseDefinition[]>()
    .notNull()
    .default([...DEFAULT_FOLLOW_UP_PHASES]),
  approvalRequiredForOpen: boolean('approval_required_for_open').notNull().default(true),
  approvalTimeoutDays: integer('approval_timeout_days').notNull().default(7),
  reminderEnabled: boolean('reminder_enabled').notNull().default(true),
  reminderSendHour: integer('reminder_send_hour').notNull().default(9),
  /** リマインドを登録済みの日付（JST, YYYY-MM-DD）。5分毎のジョブが同じ日に二重登録しないための印 */
  reminderLastRunOn: text('reminder_last_run_on'),
  tenantId: uuid('tenant_id')
    .notNull()
    .references(() => tenants.id, { onDelete: 'cascade' })
    .unique(),
  createdAt: timestamp('created_at').notNull().defaultNow(),
  updatedAt: timestamp('updated_at').notNull().defaultNow(),
})

// Relations
export const tenantTrainingConfigsRelations = relations(tenantTrainingConfigs, ({ one }) => ({
  tenant: one(tenants, {
    fields: [tenantTrainingConfigs.tenantId],
    references: [tenants.id],
  }),
}))

// Type exports
export type TenantTrainingConfig = typeof tenantTrainingConfigs.$inferSelect
export type NewTenantTrainingConfig = typeof tenantTrainingConfigs.$inferInsert
